import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { api } from "../../api/client";
import { useUi } from "../../state/ui";
import { effectiveOpo } from "./useDeployment";

/** Ordre de bataille des paramètres en cours, comme le déploiement : celui du dossier enregistré, sinon un
 *  aperçu du brouillon des Données initiales ; en CENTAC, celui de l'OPO affiché. */
export function useOrbat() {
  const params = useUi((s) => s.deploymentParams);
  const opo = effectiveOpo(params, useUi((s) => s.opo));
  return useQuery({
    queryKey: ["orbat", params, opo] as const,
    queryFn: () =>
      params!.exercise_id ? api.exerciseOrbat(params!.exercise_id, opo) : api.orbat({ ...params!, opo }),
    enabled: Boolean(params),
    placeholderData: keepPreviousData,
    retry: false,
    staleTime: 5 * 60_000,
  });
}
